export default (args: {dispatchDataV2: any}) => (ids: string[], keyValuesPairs: any) => {

  args.dispatchDataV2({type: "UPDATE_CANDIDACIES_BULK", value: keyValuesPairs})
}